import React, { useRef, useState, useEffect } from 'react';
import Quill from 'quill';
import Editor from './Editor';
import 'quill/dist/quill.snow.css';

export default function EditorTable({ content }) {
  const [defaultValue, setDefaultValue] = useState(null);
  const quillRef = useRef();

  useEffect(() => {
    if (!content) return;

    const Delta = Quill.import('delta');
    const delta = new Delta().insert(content + '\n');
    setDefaultValue(delta);
  }, [content]);

  useEffect(() => {
    if (defaultValue && quillRef.current) {
      quillRef.current.setContents(defaultValue);
    }
  }, [defaultValue]);

  if (defaultValue === null) return null;

  return (
    <div style={styles.editorWrapper}>
      <Editor
        ref={quillRef}
        defaultValue={defaultValue}
      />
    </div>
  );
}

const styles = {
  editorWrapper: {
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#fff',
  },
};
